import { MONTHS } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useGetExpenseChartData } from "@/services";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useBudgetExpenseChart = () => {
  const [chartData, setChartData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Budget Expense",
        data: [],
        borderColor: "#3EA44B",
        backgroundColor: "#3EA44B",
        tension: 0.4,
        pointStyle: "circle",
        pointRadius: 6,
      },
      {
        label: "Actual Expense",
        data: [],
        borderColor: "#245DB1",
        backgroundColor: "#245DB1",
        tension: 0.4,
        pointStyle: "circle",
        pointRadius: 6,
      },
    ],
  });

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );

  const { data: chartAPIData, isLoading: isChartDataLoading } =
    useGetExpenseChartData({
      communityId: communityDetail?.communityId,
      year: currentFinanceYear,
      queryParams: {
        enabled: !!(communityDetail?.communityId && currentFinanceYear),
      },
    });

  useEffect(() => {
    if (chartAPIData) {
      const budgetExpense = MONTHS?.map((mon: string) => {
        return chartAPIData?.data?.find(
          (val: any) => val?.monthName?.toLowerCase() == mon?.toLowerCase()
        )?.budgetAmount;
      });
      const actualExpense = MONTHS?.map((mon: string) => {
        return chartAPIData?.data?.find(
          (val: any) => val?.monthName?.toLowerCase() == mon?.toLowerCase()
        )?.actualAmount;
      });

      let _chartData = { ...chartData };
      _chartData = {
        labels: MONTHS as any,
        datasets: [
          {
            ..._chartData["datasets"][0],
            data: budgetExpense,
          },
          {
            ..._chartData["datasets"][1],
            data: actualExpense,
          },
        ],
      };
      setChartData({ ..._chartData });
    }
  }, [chartAPIData]);

  return {
    chartData,
    isChartDataLoading,
    currentFinanceYear,
  };
};

export default useBudgetExpenseChart;
